import React from "react";
import "./PreConferenceHeader.css";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import Logo1 from "../../Assets/Picture1.png";
import Logo2 from "../../Assets/Picture2.png";
import Logo3 from "../../Assets/NewImages/New_Logo.jpg";

const PreConferenceHeader = () => {
  return (
    <div className="preconferenceHeader position-relative text-white">
      <div className="preconferenceHeader-overlay"></div>
      <Container className="preconferenceHeader-content text-center">
        <Row className="justify-content-center">
          <Col md={10}>
            <div className="preconferenceHeader-timer d-flex justify-content-center flex-wrap mb-4">
              {/* <div className="preconferenceHeader-timeBox">
                <h2 className="yellow">26</h2>
                <p>DAY</p>
              </div>
              <div className="preconferenceHeader-timeBox">
                <h2 className="orange">SEP</h2>
                <p>MONTH</p>
              </div>
              <div className="preconferenceHeader-timeBox">
                <h2 className="blue">2025</h2>
                <p>YEAR</p>
              </div> */}
            </div>
            <div
              style={{
                zIndex: 2,
                backdropFilter: "blur(8px)",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                borderRadius: "20px",
                padding: "0.5rem 1rem 0.5rem 1rem",
                boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
                marginBottom: "1rem",
                marginTop: "1rem",
                width: "70%",
                maxWidth: "70%",
              }}
              className="mx-auto"
            >
              {/* Logos */}
              <Row className="justify-content-between mb-2 gx-3">
                <Col xs={6} sm={4} className="">
                  <Image
                    src={Logo3}
                    fluid
                    style={{ maxHeight: "120px", marginTop: "30px" }}
                  />
                </Col>
                <Col xs={6} sm={4} className="">
                  <Image src={Logo1} fluid style={{ maxHeight: "120px" }} />
                </Col>
                {/* <Col xs={6} sm={4} className="">
              <Image src={Logo2} fluid style={{ maxHeight: "120px" }} />
            </Col> */}
              </Row>
            </div>
            <p>Pre-Conference Hands-On Workshop on</p>
            <h1 className="preconferenceHeader-title">
              Hybrid Planning Strategies for Breast Cancer &nbsp;
              <span className="preconferenceHeader-2021">2025</span>
            </h1>
            <p className="preconferenceHeader-location">
              Platform: Varian Eclipse and Elekta Monaco TPS
            </p>
            <p className="preconferenceHeader-location">
              Venue: Department of Radiation Oncology, Apollo Cancer Centre,
              Vanagaram.
            </p>
            <Button className="preconferenceHeader-button">
              Date: 26th September 2025
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PreConferenceHeader;
